import TYPES from './types';

export const togglePanel = panel => dispatch => {
  dispatch({ type: TYPES.TOGGLE_PANEL, payload: panel });
};

export const collapseMenu = () => dispatch => {
  dispatch({ type: TYPES.COLLAPSE_MENU });
};
